module.exports = __webpack_public_path__ + "img/points.7a522f31.png";